/**
 * @generated SignedSource<<60890450e07a0c6350364d5c2503ec22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BindingCriteria_bindings$data = {
  readonly bindings: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
        readonly uuid: any;
      };
    }>;
  };
  readonly " $fragmentType": "BindingCriteria_bindings";
};
export type BindingCriteria_bindings$key = {
  readonly " $data"?: BindingCriteria_bindings$data;
  readonly " $fragmentSpreads": FragmentRefs<"BindingCriteria_bindings">;
};

import BindingCriteriaBindingsPaginationQuery_graphql from './BindingCriteriaBindingsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "bindings"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": BindingCriteriaBindingsPaginationQuery_graphql
    }
  },
  "name": "BindingCriteria_bindings",
  "selections": [
    {
      "alias": "bindings",
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "filter"
        }
      ],
      "concreteType": "BindingConnection",
      "kind": "LinkedField",
      "name": "__BindingCriteria__bindings_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BindingEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Binding",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "da399ec8fc771cb74ba90ee156636251";

export default node;
